import { z } from 'zod';
import { grade } from '#enums/class';
export const addressSchema = z.object({
    streetNumber: z.string().min(1, { message: 'Le numéro de rue est requis' }),
    street: z.string().min(1, { message: 'La rue est requise' }),
    postalCode: z.string().min(1, { message: 'Le code postal est requis' }),
    city: z.string().min(1, { message: 'La commune est requise' }),
    country: z.string().min(1, { message: 'Le pays est requis' }),
});
export const freeUserRegistrationSchema = z.object({
    lastName: z.string().min(1, {
        message: 'Le nom est requis',
    }),
    firstName: z.string().min(1, {
        message: 'Le prénom est requis',
    }),
    phoneNumber: z.string().min(1, {
        message: 'Le téléphone est requis',
    }),
    utmSource: z.string().optional(),
    grade: z.enum(grade, {
        required_error: 'Le niveau est requis',
    }),
});
